import { Navigate, Outlet } from "react-router-dom";
import localStorageServices from "../services/LocalStorage";
import { LocalStorageKeys } from "../constant/LocalStorageKeys";
import { NavigationRoutes } from "../constant/Routes";


export const isAuthenticated = () => {
    const token =  localStorageServices.getItem(LocalStorageKeys.userToken);//A
    if (token) {
        return true;
    }else{

        return false;
    }
};

const PrivatRoutes = () => {
    const auth = isAuthenticated();

    
    // console.log(isAuth)
    return auth ? <Outlet /> : <Navigate to= {NavigationRoutes.LOGIN} />;
};

export default PrivatRoutes;